module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/plusvalia.cb6a31d1.svg";